import React, { useState, useEffect } from "react";
import profilePicture from "../assests/My-Picture.jpg";

function MainSection() {
  const qualityList = [
    "Anime Fan 🤡",
    "Bookworm 📚",
    "Coder 💻",
    "Chocoholic 🍫",
    "Dogophile 🐶",
    "Explorer 🕸",
    "Foodie 🥪",
    "Gamer 🎮",
    "Green Panther 🌳",
    "Noob Artist 🎨",
    "Parrot Servant 🦜",
    "Potterhead 👻",
  ];

  const [qua, setQua] = useState("Adventurous ⛵");

  useEffect(() => {
    let i = 0;
    let interval = setInterval(() => {
      setQua(qualityList[i]);
      i = (i + 1) % qualityList.length;
    }, 1500);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <section className="main-section">
      <img
        className="profile-pic-img"
        src={profilePicture}
        alt="My Profile Picture"
      />
      <div className="main-text-content">
        <h1 className="main-text-greeting">Namaste!</h1>
        <p className="main-text">
          I'm
          <strong className="nowrap"> Shalu Ambasta </strong>
        </p>
        <p className="dev-qualities main-text nowrap">{qua}</p>
      </div>
    </section>
  );
}

export default MainSection;
